import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons"
import { ExternalLink } from "../links/ExternalLink"
import { StandardButton } from "../buttons/StandardButton"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons"

const DISCLAIMER_STORAGE_KEY = "order-chat-disclaimer-accepted"

const useStyles = makeStyles()((theme) => ({
    infoWrap: {
        display: "grid",
        alignItems: "flex-start",
        gridTemplateColumns: "1rem 1fr",
        borderRadius: "0.5rem",
        gap: ".75rem",
        padding: "0.75rem",
        color: theme.palette.tailwind.sky[700],
        backgroundColor: theme.palette.tailwind.sky[50],
        width: "100%",
        "&> svg": {
            display: "block",
            marginTop: ".125rem",
        },
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: ".75rem",
    },
    link: {
        color: "inherit",
    },
    acceptButton: {
        alignSelf: "flex-start",
        padding: ".375rem .875rem !important",
        borderRadius: "0.625rem !important",
        backgroundColor: theme.palette.tailwind.slate[800],
        color: theme.palette.common.white,
        "&:hover": {
            backgroundColor: theme.palette.tailwind.slate[800],
        },
    },
}))

type OrderChatDisclaimerProps = Readonly<{
    onAccept: () => void
}>

export function isDisclaimerAccepted(): boolean {
    return localStorage.getItem(DISCLAIMER_STORAGE_KEY) === "true"
}

export function acceptDisclaimer(): void {
    localStorage.setItem(DISCLAIMER_STORAGE_KEY, "true")
}

export function OrderChatDisclaimer({ onAccept }: OrderChatDisclaimerProps) {
    const { classes } = useStyles()

    const handleAccept = () => {
        acceptDisclaimer()
        onAccept()
    }

    return (
        <Box className={classes.infoWrap}>
            <FontAwesomeIcon icon={faCircleInfo} />
            <Box className={classes.content}>
                <LocalizedStrict id="order-chat-disclaimer-text">
                    <Typography variant="body2">
                        This chat is used to communicate about the order. Messages will not appear on the order
                        specification.
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict id="order-chat-disclaimer-warning">
                    <Typography variant="body2">
                        NOTE: Avoid entering sensitive personal information, e.g. if you are vegetarian, have allergies.
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict
                    id="order-chat-disclaimer-link"
                    elems={{
                        a: (
                            <ExternalLink href="#" className={classes.link}>
                                here
                            </ExternalLink>
                        ),
                    }}
                >
                    <Typography variant="body2">{"Read more <a>here</a>."}</Typography>
                </LocalizedStrict>
                <LocalizedStrict id="order-chat-disclaimer-accept">
                    <StandardButton
                        color="grey"
                        fullWidth={false}
                        onClick={handleAccept}
                        className={classes.acceptButton}
                    >
                        Accepted
                    </StandardButton>
                </LocalizedStrict>
            </Box>
        </Box>
    )
}
